import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowTopRightOnSquareIcon, DocumentIcon, FilmIcon, PhotoIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from '../../../../empreenderUI/ui/Drawer';
import Input from '../../../../empreenderUI/ui/Input';
import LoadingLogo from '../../../../components/Loading-logo';
import PaginationModalFiles from '../tailwind/pagination-modal-files';
import { translations } from '../../../../utils/language';

const ModalAnexarGaleria = (props) => {
  const dispatch = useDispatch();
  const medias = useSelector((state) => state.reducerMedias);
  const language = useSelector((state) => state.reducerLanguage);

  const closeModal = () => {
    props.handleClick?.();
    setTimeout(() => {
      props.setVisible(false);
      dispatch({ type: 'VARIANTS_CONTROL_RESET' });
      props.close?.();
    }, 100);
  };

  const handleOpenChange = (open) => {
    if (!open) closeModal();
  };

  const changePage = (page) => {
    props.setPageFiles(page);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      props.goSearchFiles?.();
    }
  };

  const subtitle = props.contextLabel || translations['products-galeria-desc'][language.data];
  const eyebrow = props.eyebrow;

  return (
    <Drawer open={!!props.visible} onOpenChange={handleOpenChange} direction='right'>
      <DrawerContent className='!w-[min(420px,100vw)] !max-w-[min(420px,100vw)] !h-full !max-h-[100dvh] border-l border-gray-200 p-0 flex flex-col overflow-hidden bg-white'>
        <DrawerHeader className='relative shrink-0 space-y-0 bg-white px-6 pt-6 pb-2'>
          <div className='flex items-start justify-between gap-3 pr-10'>
            <div className='min-w-0 space-y-1'>
              <DrawerTitle className='text-xl font-bold tracking-tight text-gray-900'>{translations['products-anexar-galeria'][language.data]}</DrawerTitle>
              <DrawerDescription className='text-sm font-medium text-gray-500'>{subtitle}</DrawerDescription>
            </div>
          </div>
          <DrawerClose asChild>
            <button type='button' className='absolute right-4 top-4 inline-flex size-8 items-center justify-center rounded-lg bg-gray-100 text-gray-700 transition-colors hover:bg-gray-200' aria-label={translations['common-close'][language.data]}>
              <XMarkIcon className='size-5' />
            </button>
          </DrawerClose>
        </DrawerHeader>

        <div className='flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto px-6 py-4 custom-scroll'>
          {medias?.loading === true ? (
            <div className='flex flex-1 items-center justify-center py-16'>
              <LoadingLogo />
            </div>
          ) : (
            <>
              <div className='flex flex-col gap-1.5'>
                <label className='text-xs font-medium text-gray-500'>{translations['products-galeria-buscar-label'][language.data]}</label>
                <Input type='text' value={props.searchFiles} onChange={(e) => props.setSearchFiles(e.target.value)} onKeyDown={handleSearchKeyDown} placeholder={translations['products-galeria-buscar'][language.data]} />
              </div>

              <div className='flex flex-col gap-2'>
                {medias?.data?.data?.map((file) => (
                  <CardFile key={file.id} setDataFilesTrue={props.setDataFilesTrue} dataFilesTrue={props.dataFilesTrue} file={file} goSearch={props.goSearch} />
                ))}
              </div>

              <div className='mt-auto pt-2'>
                <PaginationModalFiles setPage={changePage} />
              </div>
            </>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default ModalAnexarGaleria;

const CardFile = (props) => {
  const [loading, setLoading] = useState(false);
  const reducerControlVariants = useSelector((state) => state.reducerControlVariants);
  const language = useSelector((state) => state.reducerLanguage);

  const getIconFile = (type) => {
    switch (type?.toLowerCase()) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'psd':
      case 'svg':
      case 'webp':
        return (
          <span className='inline-flex size-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600'>
            <PhotoIcon className='size-4' />
          </span>
        );
      case 'mp4':
      case 'avi':
      case 'mkv':
        return (
          <span className='inline-flex size-9 shrink-0 items-center justify-center rounded-lg bg-purple-50 text-purple-600'>
            <FilmIcon className='size-4' />
          </span>
        );
      case 'url':
        return (
          <span className='inline-flex size-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600'>
            <ArrowTopRightOnSquareIcon className='size-4' />
          </span>
        );
      default:
        return (
          <span className='inline-flex size-9 shrink-0 items-center justify-center rounded-lg bg-gray-50 text-gray-600'>
            <DocumentIcon className='size-4' />
          </span>
        );
    }
  };

  const anexarFile = async () => {
    setLoading(true);

    const token = JSON.parse(localStorage.getItem('depoimentos@login'))?.access_token.token;
    const url = `${process.env.REACT_APP_API_URL}/link_media_product`;
    const headers = new Headers({ Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' });

    await Promise.all(
      reducerControlVariants.data.map((variant) =>
        fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            media_id: props.file.id,
            product_id: variant.variants.product_id,
            variant_id: variant.variants.variant_id,
          }),
        }).then((response) => {
          if (!response.ok) {
            throw new Error(`Erro na requisição para variante ${variant.variant_id}: ${response.statusText}`);
          }
          return response.json();
        }),
      ),
    );

    setLoading(false);
    props.setDataFilesTrue((prevData) => [...prevData, props.file]);
    props.goSearch?.();
  };

  const verify = () => props.dataFilesTrue.some((existingMedia) => existingMedia?.id === props?.file?.id);

  const attached = verify();
  const actionLabel = loading ? translations['products-galeria-anexando'][language.data] : attached ? translations['products-galeria-anexado'][language.data] : translations['products-galeria-anexar'][language.data];

  return (
    <div className='flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3'>
      {getIconFile(props.file.type)}
      <p className='min-w-0 flex-1 truncate text-sm font-medium text-gray-900'>{props.file.media_name}</p>
      <button
        type='button'
        disabled={attached || loading}
        onClick={() => {
          if (!attached && !loading) anexarFile();
        }}
        className={`shrink-0 text-sm font-medium transition-colors ${attached || loading ? 'cursor-default text-gray-400' : 'text-blue-600 hover:text-blue-700'}`}
      >
        {actionLabel}
      </button>
    </div>
  );
};
